export const ELEVATION = {
  elevation0: '0px 2px 4px rgba(15, 15, 15, 0.08)',
  elevation8: '0px 0px 4px rgba(15, 15, 15, 0.16)',
  elevation16: '0px 0px 2px rgba(0, 0, 0, 0.4)',
  elevationGaugeHover: '1px 1px 6px 0px rgba(15, 15, 15, 0.26)',
  elevationCustomInput: '0px 1px 3px 0px rgba(0,0,0,0.05), 0px 8px 16px -4px rgba(0,0,0,0.08)',
} as const;
